import React from 'react'
import { RatingChipsStyles } from './Style'
import { Chip } from 'components/Form'
import { ratingListLabel, ratingText } from 'keys/rating'

const RatingChips = (props) => {
    const { type = "BASIC" } = props

    const basicChips = {
        "rating2": {
            color: "rating2",
            icon: "fa-light fa-face-smile",
            label: "ביצועים טובים"
        },
        "rating5": {
            color: "rating5",
            icon: "fa-regular fa-face-dizzy",
            label: "ביצועים נמוכים"
        },
    }

    const profileChips = {
        "rating1": {
            color: "rating1",
            icon: "fa-regular fa-face-grin-stars"
        },
        "rating2": {
            color: "rating2",
            icon: "fa-regular fa-face-smile"
        },
        "rating3": {
            color: "rating3",
            icon: "fa-regular fa-face-meh"
        },
        "rating4": {
            color: "rating4",
            icon: "fa-regular fa-face-frown"
        },
        "rating5": {
            color: "rating5",
            icon: "fa-regular fa-face-dizzy"
        }
    }

    const profile = type == "PROFILES" ? profileChips : basicChips

    return (
        <RatingChipsStyles>
            {Object.keys(profile).map((key, index) =>
                <Chip color={profile[key].color}>
                    <i class={profile[key].icon}></i>
                    {profile[key].label || ratingListLabel[index]}
                </Chip>
            )}
        </RatingChipsStyles>
    )
}

export default RatingChips